var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Hero',{attrs:{"title":_vm.moduleData.title}}),_vm._v(" "),_c('PressContent',{attrs:{"content":_vm.articleContent}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }